import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { TenantState } from 'src/app/store/state/tenant.state';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastGlobalService } from '../../layout/toast-global/toast-global.service';
import { TranslateService } from '@ngx-translate/core';
import { DynamicDialogService } from '../../dynamic-dialog/dynamic-dialog.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { TenantStateService } from 'src/app/shared/services/tenant.state.service';
import { Observable, Subject } from 'rxjs';
import { distinctUntilChanged, finalize, map, takeUntil } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth.service';
import { DvirService } from '../dvir/dvir.service';
import { Dvir } from 'src/app/models/dvir';
import { TelematicDriverService } from 'src/app/shared/services/telematic-driver.service';
import { SpaRoutingService } from 'src/app/shared/services/spa.routing.service';
import { Dictionary } from 'lodash';
import { DvirDefect } from 'src/app/models/dvirDefect';
import { MatTableDataSource } from '@angular/material/table';
@Component({
    selector: 'app-dvir-detail',
    templateUrl: './dvir-detail.component.html',
    styleUrls: ['./dvir-detail.component.css'],
    standalone: false
})
export class DvirDetailComponent implements OnInit, OnDestroy {
    @SelectSnapshot(TenantState.getCurrentTenantExternalId) getExternalId: string;
    @SelectSnapshot(TenantState.getLanguage) getLanguage: string;
    @ViewChild('tabGroup') tabGroup;
    canEdit = false;
    editable = false;
    loading: boolean = false;
    destroy$ = new Subject();
    telematicDriver$: Observable<Dictionary<string>>;
    defectDataSource: MatTableDataSource<DvirDefect>;
    tenantId: string;
    dvir: Dvir;
    selectedIndex: any = 0;
    dvirForm = new UntypedFormGroup({
        vin: new UntypedFormControl(),
        dvirCreateDateTimeUtc: new UntypedFormControl()
    })

    constructor(
        private readonly route: ActivatedRoute,
        private readonly toastGlobalService: ToastGlobalService,
        private readonly formBuilder: UntypedFormBuilder,
        private readonly dialogService: DynamicDialogService,
        private readonly tenantStateService: TenantStateService,
        private readonly router: Router,
        private readonly snackBar: MatSnackBar,
        private readonly translate: TranslateService,
        private readonly authService: AuthService,
        private readonly dvirService: DvirService,
        private telematicDriverService: TelematicDriverService,
        private spaRoutingService: SpaRoutingService) {
      }

      ngOnInit(): void {
        this.tenantId = this.getExternalId;

        this.route.paramMap.pipe(
          map(params => params.get('id')),
          distinctUntilChanged(),
          takeUntil(this.destroy$)
        ).subscribe(id => {
          this.setupData(id);
        });
      }

      ngOnDestroy(): void {
        this.destroy$.next(true);
        this.destroy$.complete();
      }

      private setupData(id: string | null): void {
        if (this.dvirService.selectedDvir && id && this.dvirService.selectedDvir.id === id) {
          this.dvir = this.dvirService.selectedDvir;

          this.fetchDrivers(this.dvir);
          this.defectDataSource = new MatTableDataSource(this.dvir.defectList);
          this.reactiveForm();
        }
        else if (id) {
          this.getData(id);
        }
        else {
            // handle creating new dvir when this component is editable
        }
      }

      private getData(id: string): void {
        this.loading = true;
        this.dvirService.getDvirById(id)
          .pipe(finalize(() => this.loading = false))
          .subscribe(res => {
            this.dvir = res;
            this.fetchDrivers(this.dvir);
            this.dvirService.selectedDvir = this.dvir;
            this.defectDataSource = new MatTableDataSource(this.dvir.defectList);
            this.reactiveForm();
          });
      }

      fetchDrivers(dvir: Dvir): void {
          var driverList = new Set<string>();
          if (this.dvir?.driver) {
            driverList.add(this.dvir.driver);
          }
          if (this.dvir?.certifiedBy) {
            driverList.add(this.dvir.certifiedBy);
          }
          this.dvir?.defectList.map(defect => {
            if (defect?.repairedBy) {
              driverList.add(defect.repairedBy);
            }
          });
          this.telematicDriver$ = this.telematicDriverService.getDrivers([...driverList], this.dvir.telematicProvider);
      }

      reactiveForm(): void {
        this.dvirForm = this.formBuilder.group({
            vin: [{ value: this.dvir.vin ?? '', disabled: !this.editable }],
            dvirCreateDateTimeUtc: [{ value: this.dvir.dvirCreateDateTimeUtc ?? '', disabled: !this.editable }],
            logType: [{ value: this.dvir.logType ?? '', disabled: !this.editable }],
            notes: [{ value: this.dvir.notes ?? '', disabled: !this.editable }],
            driver: [{ value: this.dvir.driver ?? '', disabled: !this.editable }],
            isSafeToOperate: [{ value: this.dvir.isSafeToOperate ?? '', disabled: !this.editable }],
        });
      }

      selectedIndexChanged(event): void {
        this.selectedIndex = event;
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: {
            tabIndex: this.selectedIndex
          },
          replaceUrl: true
        });
      }

      displayDriver(dict: Dictionary<string>, driverId: string, telematicProvider: string): string {
        if (driverId === undefined || driverId == '') {
          return '';
        }
        return dict[this.telematicDriverService.driverKey(driverId,telematicProvider)] 
            ?? "Id: "+driverId;
      }

      goToVehicleDetail(): void {
        this.spaRoutingService.navigateToVehicle(this.dvir.vin);
      }
}